/** Price → ≤2-decimal string (whole numbers stay whole), or '-' when absent. Guards against backend float noise like `50.0000019375`. */
export function formatPriceAmount(price: number | null | undefined): string {
  if (price == null) return '-';
  return String(Math.round(price * 100) / 100);
}

/**
 * Price → grouped currency string with exactly two decimals (e.g. "$1,200.00"), for
 * amounts quoted inside prose. Distinct from {@link formatPriceAmount}, which drops
 * trailing zeros for the large price figures rendered beside a separate symbol.
 */
export function formatCurrencyAmount(
  amount: number | null | undefined,
  currencySymbol = '$'
): string {
  return `${currencySymbol}${(amount ?? 0).toLocaleString('en-US', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  })}`;
}
